import { ConcreteEncodable } from "./ConcreteEncodable";

import { OrderPTPCompositeImplEncoder } from "../../encoder/OrderPTPCompositeImplEncoder";

import * as CubiqTS from "../../index";
import { OrderPTPComposite } from "../OrderPTPComposite";

export class OrderPTPCompositeImpl extends ConcreteEncodable implements OrderPTPComposite {
  public static enType: string = "com.bcdfx.model.event.OrderPTPCompositeImpl";

  /*FID=1*/
  public orderId: string;
  /*FID=2*/
  public passThroughParameters: Array<CubiqTS.StrategyParameter> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OrderPTPCompositeImplEncoder.Instance;
    this.setEncodableType(OrderPTPCompositeImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "OrderPTPCompositeImpl[" +
      "orderId=" +
      this.orderId +
      "passThroughParameters=" +
      this.passThroughParameters +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
